import { render } from "./HeaderTherapist.vue?vue&type=template&id=6311a84a&scoped=true&ts=true"
import script from "./HeaderTherapist.vue?vue&type=script&lang=ts"
export * from "./HeaderTherapist.vue?vue&type=script&lang=ts"

import "./HeaderTherapist.vue?vue&type=style&index=0&id=6311a84a&scoped=true&lang=scss"

import exportComponent from "/builds/Moodbuster2.0/server/web-server/repos/patient_portal_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6311a84a"]])

export default __exports__